import store from '../store/index'
import router from '../router/index'
import MobileAnalyticsApi from '@/api/MobileAnalyticsApi';

function parseLogObj(logObj: any) {
    return {
        type: logObj.attributes.type,
        userId: logObj.attributes.userId,
        payload: logObj.attributes.payload,
        createdAt: logObj.meta.createdAt,
    };
}

export default {
    async getTenantLogsPage(tenantUUID: string, params: any = {}): Promise<{ logs: any[], nextCursor: string | null }> {
        if (!store.getters.loggedIn(Date.now())) {
            router.push('/login');
        }
        const response = await MobileAnalyticsApi.getTenantLogsCollection(tenantUUID, params);
        return {
            logs: response.data.data.map(parseLogObj),
            nextCursor: response.data.links?.next || null,
        };
    },
    async getUserLogsPage(tenantUUID: string, userUUID: string, params: any = {}): Promise<{ logs: any[], nextCursor: string | null }> {
        if (!store.getters.loggedIn(Date.now())) {
            router.push('/login');
        }
        const response = await MobileAnalyticsApi.getUserLogsCollection(tenantUUID, userUUID, params);
        return {
            logs: response.data.data.map(parseLogObj),
            nextCursor: response.data.links?.next || null,
        };
    },
    async getLatestVersion(slug: string): Promise<any> {
        const response = await MobileAnalyticsApi.getLatestVersion(slug);
        return {
            version: response.data.data.attributes.version,
            createdAt: response.data.data.meta.createdAt,
        };
    },
}
